/* Copyright (c) 2022-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

export enum InputSymbol {
    Space = 'Space',
    CapsLock = 'CapsLock',
    Backspace = 'Backspace',
    ArrowLeft = 'ArrowLeft',
    ArrowRight = 'ArrowRight',
    Enter = 'Enter',
    Escape = 'Escape',
    PrimaryType = 'abc',
    SecondaryType = '*&$'
}

export enum CapsLockState {
    Off = 0,
    Once,
    Always
}

export const KeysToCode = new Map([
    [['0', ')'], 'Digit0'],
    [['1', '!'], 'Digit1'],
    [['2', '@'], 'Digit2'],
    [['3', '#'], 'Digit3'],
    [['4', '$'], 'Digit4'],
    [['5', '%'], 'Digit5'],
    [['6', '^'], 'Digit6'],
    [['7', '&'], 'Digit7'],
    [['8', '*'], 'Digit8'],
    [['9', '('], 'Digit9'],

    [[';', ':'], 'Semicolon'],
    [['/', '?'], 'Slash'],
    [['`', '~'], 'Backquote'],
    [['[', '{'], 'BracketLeft'],
    [['\\', '|'], 'Backslash'],
    [[']', '}'], 'BracketRight'],
    [["'", '"'], 'Quote'],
    [['.', '>'], 'Period'],
    [[',', '<'], 'Comma'],
    [['-', '_'], 'Minus'],
    [['=', '+'], 'Equal']
]);

export const KeysToKbNonPrintableCode = new Map([
    [[';', ':'], 0xba],
    [['=', '+'], 0xbb],
    [[',', '<'], 0xbc],
    [['-', '_'], 0xbd],
    [['.', '>'], 0xbe],
    [['/', '?'], 0xbf],
    [['`', '~'], 0xc0],
    [['[', '{'], 0xdb],
    [['\\', '|'], 0xdc],
    [[']', '}'], 0xdd],
    [["'", '"'], 0xde]
]);

export enum HotkeyModifierFlag {
    Shift = 0x0001,
    Control = 0x0002,
    Alt = 0x0004
}

export enum HotkeyByteMask {
    Lower = 0xff
}

export enum WindowsVirtualKey {
    Alt = 0x12,
    Control = 0x11,
    Shift = 0x10
}

export enum HotkeyBitShift {
    Left = 8
}
